<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('name')" style="text-align: left;">
				Nyligt åbnede emner
			</th>
			<th class="sortable active" @click="sort('date')">
				Åbnet
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(item, index) in (sortedActivity, filteredList)" :key="index" @click="gotoItem(item)">
					<td>
						{{ item.name }}
						<div class="small faded">
							{{ getItemTypeName(item) }}
						</div>
					</td>
					<td v-text="item.datepretty"></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(item, index) in (sortedActivity, filteredList)" :key="index" @click="gotoItem(item)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn">
								{{ item.name }}
								<div class="small faded">
									{{ getItemTypeName(item) }}
								</div>
							</li>
							<li data-label="Dato">{{ item.datepretty }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Intet fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Igen nylig aktivitet gemt.
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { systemTypeEnum } from "@/app/enums/common";

	export default {
		name: "RecentItemsList",
		data: () => ({
			data: [],
			currentSort: "date",
			currentSortDir: "desc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html

				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var items = this.data
				return items.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				if (!this.data || this.data.length == 0)
				{
					return []
				}
				
				var items = this.data
				return items.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					return name;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		mounted()
		{
			this.loadData()
		},
		methods:
		{
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_USER_RECENTITEMS)
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("RecentItemsList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},

			getItemTypeName(item)
			{
				switch (item.type)
				{
					case systemTypeEnum.USER:
						return "Bruger";
					case systemTypeEnum.COMPANY:
						return "Virksomhed";
					case systemTypeEnum.CUSTOMER:
						return "Institution";
					case systemTypeEnum.AGREEMENT:
						return "Aftale";
					case systemTypeEnum.PERSONGROUP:
						return "Gruppe";
					case systemTypeEnum.PERSON:
						return "Person";
					case systemTypeEnum.PRODUCT:
						return "Produkt";
					case systemTypeEnum.PRODUCTPACKAGE:
						return "Produktpakke";
					case systemTypeEnum.MEDIA:
						return "Medie";
					case systemTypeEnum.ORDER:
						return "Ordre";
					case systemTypeEnum.CLIENT:
						return "Kunde";
					default:
						"Ukendt"
				}
			},
			gotoItem(item)
			{
				switch (item.type)
				{
					case systemTypeEnum.USER:
						this.setModalProfileEditVisibility(true)
						break;
					case systemTypeEnum.COMPANY:
						return null;
					case systemTypeEnum.CUSTOMER:
						this.$router.push({ name: "CustomerEdit", params: { customerid: item.itemid } })
						break;
					case systemTypeEnum.AGREEMENT:
						this.$router.push({ name: "AgreementEditFromList", params: { customerid: item.parentitemid, agreementid: item.itemid } })
						break;
					case systemTypeEnum.PERSONGROUP:
						this.$router.push({ name: "PersonGroupEdit", params: { customerid: item.parentitemid, persongroupid: item.itemid } })
						break;
					case systemTypeEnum.PERSON:
						this.$router.push({ name: "PersonEdit", params: { customerid: item.parentitemid, personid: item.itemid } })
						break;
					case systemTypeEnum.PRODUCT:
						this.$router.push({ name: "ProductEdit", params: { productid: item.itemid } })
						break;
					case systemTypeEnum.PRODUCTPACKAGE:
						this.$router.push({ name: "ProductPackageEdit", params: { productpackageid: item.itemid } })
						break;
					case systemTypeEnum.MEDIA:
					case systemTypeEnum.ORDER:
					case systemTypeEnum.CLIENT:
						break;
					default:
						return null;
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
